import { IBannerReponse } from "../../../model/base/response/banner-response";
import { IGroupedBidsYearResponse } from "../../../model/base/response/grouped-bids-year-response";
import { IGroupedDailyOfficialResponse } from "../../../model/base/response/grouped-daily-official-response";
import { IGroupedPublicAccountBySubCategoryResponse } from "../../../model/base/response/grouped-public-account-subcategory-response";
import { IManagementUnitResponse } from "../../../model/base/response/management-unit-response";
import { IMenuResponse } from "../../../model/base/response/menu-response";
import { INewsReponse } from "../../../model/base/response/news-response";
import { ICategoryWithSubcategoriesResponse } from "../../../model/base/response/category-with-subcategories-response";


export type HomeState = {
  menus: IMenuResponse[];
  banners: IBannerReponse[];
  topNews: INewsReponse[];
  groupedDailyOfficial: IGroupedDailyOfficialResponse[];
  groupedBidsYear: IGroupedBidsYearResponse[];
  groupedPublicAccountSubcategory: IGroupedPublicAccountBySubCategoryResponse[];
  managementUnit: IManagementUnitResponse[];
  categoriesWithSubcategories: ICategoryWithSubcategoriesResponse[];
};

export enum ACTION_TYPES {
  setBanners = 'setBanners',
  setMenus = 'setMenus',
  setTopNews = 'setTopNews',
  setGroupedDailyOfficial = 'setGroupedDailyOfficial',
  setGroupedBidsModality = 'setGroupedBidsModality',
  setGroupedPublicAccountSubcategory = 'setGroupedPublicAccountSubcategory',
  setManagementUnit= 'setManagementUnit',
  setCategoriesWithSubcategories = 'setCategoriesWithSubcategories',
}

export const HomeReducer = (state: HomeState, action: any): HomeState => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.setBanners:
      return {
        ...state,
        banners: payload,
      };
    case ACTION_TYPES.setMenus:
      return {
        ...state,
        menus: payload,
      };
    case ACTION_TYPES.setTopNews:
      return {
        ...state,
        topNews: payload,
      };
    case ACTION_TYPES.setGroupedBidsModality:
      return {
        ...state,
        groupedBidsYear: payload,
      };
    case ACTION_TYPES.setGroupedDailyOfficial:
      return {
        ...state,
        groupedDailyOfficial: payload,
      };
    case ACTION_TYPES.setGroupedPublicAccountSubcategory:
      return {
        ...state,
        groupedPublicAccountSubcategory: payload,
      };
      case ACTION_TYPES.setManagementUnit:
        return {
          ...state,
          managementUnit: payload,
        };
      case ACTION_TYPES.setCategoriesWithSubcategories:
        return {
          ...state,
          categoriesWithSubcategories: payload,
        };

    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
}